export default __webpack_public_path__ + "static/bullet-background-740ef0737f21cdc16f25424625727577.png";